<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-13 14:56:20
 * @LastEditTime: 2020-12-21 15:58:40
 * @Description:
 -->
<template>
    <div class="single-page">
        <div class="title">{{ content.title }}</div>
        <div class="info" v-html="content.info"></div>
    </div>
</template>

<script>
import { getContent } from "../../../api/gm/api-content";
export default {
    data() {
        return {
            content: {}
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.fetchData());
    },
    beforeRouteUpdate(to, from, next) {
        this.fetchData();
    },
    created() {},
    methods: {
        //..获取数据
        fetchData() {
            if (this.$route.meta.cid) {
                //console.log(this.$route);
                getContent(this.$route.meta.cid).then(res => {
                    this.content = res.data;
                    this.content.title = this.$route.matched
                        .filter(m => m.meta.title)
                        .slice(-1)[0].meta.title;

                    this.$nextTick(() => {
                        let video = document.querySelector("video");
                        video.setAttribute("controlsList", "nodownload");

                        var options = {
                            attributes: true,
                            childList: true,
                            subtree: true,
                            attributeOldValue: true
                        };

                        function callback(mutationsList, observer) {
                            if (mutationsList[0].oldValue === "nodownload") {
                                video.setAttribute(
                                    "controlsList",
                                    "nodownload"
                                );
                            }
                            console.log(mutationsList);
                            console.log(observer);
                        }

                        var mutationObserver = new MutationObserver(callback);

                        mutationObserver.observe(video, options);
                    });
                });
            } else {
                this.content = {};
            }
        }
    }
};
</script>
<style lang="less" scoped>
.single-page {
    /deep/.title {
        color: #464646;
        font-size: 24px;
        padding: 2vw 0px 20px 0px;
        text-align: center;
    }
    .info {
        color: #464646;
        font-size: 16px;
        line-height: 28px;
        img {
            margin: 0px 1% 10px 0px;
            &:nth-child(2n) {
                margin: 0px 0px 10px 1%;
            }
        }
    }
}

@media (max-width: 1024px) {
    /deep/video {
        width: 100% !important;
    }
    .single-page {
        /deep/.title {
            font-size: 18px;
            padding: 2vw 0px 15px 0px;
        }
        .info {
            font-size: 14px;
            line-height: 22px;
            /deep/img {
                width: 100% !important;
                margin: 0px 0px 10px 0px;
                &:nth-child(2n) {
                    margin: 0px 0px 10px 0px;
                }
            }
            /deep/ video {
                width: 100% !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/single-page.vue